import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  AddListItemInner,
  AddListItemWrapper,
  ListStyledAdd,
} from "../review-stage-list/review-stage-list.styles";
import CloseIcon from "@material-ui/icons/Close";
import DragIndicatorIcon from "@material-ui/icons/DragIndicator";
import {
  Grid,
  IconButton,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
  TextField,
} from "@material-ui/core";
import { SaveOutlined } from "@material-ui/icons";
import { InlineEditWrapper } from "./add-review-stage.styles";
import {
  selectWorkOrderId,
  selectWorkOrderResourceType,
} from "../../../redux/selectors/workOrders";
import { selectExecutionBriefField } from "../../../redux/selectors/executionBriefs";
import { Nullable } from "../../../types/common";
import {
  ReviewerImage,
  ReviewerImageWrapper,
} from "../review-stage-list-item/review-stage-list-item.styles";
import { AddReviewStageProps } from "./add-review-stage.props";
import { withShowIf } from "../../with-show-if/with-show-If.component";
import { IUser } from "../../../types/user/iuser.interface";
import { UsersSearch } from "../../../features/users/components/users-search/users-search.component";
import * as campaignBriefStore from "../../../pages/campaign-brief/store/campaign-brief.store";

export const AddReviewStage = withShowIf((props: AddReviewStageProps) => {
  const { reviewStage, updateNewStage, close } = props;

  const [editMode, setEditMode] = useState(true);
  const [allowSave, setAllowSave] = useState(false);
  const [stageName, setStageName] = useState("");
  const [stageReviewer, setStageReviewer] = useState({} as IUser);

  const campaignBriefId = useSelector(campaignBriefStore.getBriefId);
  const campaignBriefResourceType = useSelector(campaignBriefStore.getResourceType);

  const executionBriefId = useSelector(selectExecutionBriefField("id"));
  const executionBriefResourceType = useSelector(selectExecutionBriefField("resourcetype"));
  const workOrderId = useSelector(selectWorkOrderId);
  const workOrderResourceType = useSelector(selectWorkOrderResourceType);

  let resourceId: Nullable<number> = null;
  let resourceType: Nullable<string> = null;

  if (workOrderId) {
    resourceId = workOrderId;
    resourceType = workOrderResourceType;
  } else if (executionBriefId) {
    resourceId = executionBriefId;
    resourceType = executionBriefResourceType;
  } else {
    resourceId = campaignBriefId;
    resourceType = campaignBriefResourceType;
  }

  const hasStageReviewer = () => Boolean(Object.keys(stageReviewer).length);

  const saveReviewer = () => {
    setEditMode(!editMode);

    if (stageName.length && hasStageReviewer()) {
      updateNewStage({
        ...reviewStage,
        name: stageName,
        reviewer: stageReviewer,
      });
      close();
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setStageName(e.target.value);

    if (hasStageReviewer() && e.target.value.length > 0) {
      setAllowSave(true);
    } else {
      setAllowSave(false);
    }
  };

  const handleSelect = (user: IUser) => {
    setStageReviewer(user);

    if (Object.keys(user).length && stageName.length > 0) {
      setEditMode(!editMode);
      updateNewStage({
        ...reviewStage,
        name: stageName,
        reviewer: user,
      });
      close();
    } else {
      setAllowSave(false);
    }
  };

  return (
    <AddListItemWrapper>
      <ListStyledAdd>
        <ListItem>
          <ListItemIcon>
            <DragIndicatorIcon />
          </ListItemIcon>
          <ListItemText>
            <AddListItemInner>
              <Grid container spacing={3} alignItems="center">
                {editMode && (
                  <Grid item sm={4} md={2}>
                    <InlineEditWrapper>
                      <TextField
                        id="newReviewer-label"
                        label="Step Name"
                        type="text"
                        value={stageName}
                        className="underlined"
                        onChange={handleChange}
                        autoComplete="off"
                        required
                      />
                    </InlineEditWrapper>
                  </Grid>
                )}
                {!editMode && (
                  <Grid item sm={4} md={2}>
                    <InlineEditWrapper>{stageName}</InlineEditWrapper>
                  </Grid>
                )}
                <Grid item sm={8} lg={6}>
                  <UsersSearch
                    showIf={stageReviewer && !stageReviewer.id}
                    id="reviewerName"
                    label="search"
                    placeholder="Search"
                    size="small"
                    resourceId={resourceId}
                    resourceType={resourceType}
                    onSelect={handleSelect}
                  />
                  {stageReviewer && stageReviewer.id && (
                    <ReviewerImageWrapper>
                      <ReviewerImage
                        alt={`${stageReviewer.firstName} ${stageReviewer.lastName}`}
                        src={(stageReviewer.profileImageUrl) ? stageReviewer.profileImageUrl : "/profile.png" }
                      />
                      {stageReviewer.firstName +' '+ stageReviewer.lastName}
                    </ReviewerImageWrapper>
                  )}
                </Grid>
              </Grid>
            </AddListItemInner>
          </ListItemText>
          <ListItemSecondaryAction>
            <IconButton onClick={saveReviewer} disabled={!allowSave} title="Save">
              <SaveOutlined />
            </IconButton>
            <IconButton onClick={close} title="Delete">
              <CloseIcon />
            </IconButton>
          </ListItemSecondaryAction>
        </ListItem>
      </ListStyledAdd>
    </AddListItemWrapper>
  );
});
